// Add your JS customizations here
jQuery(document).ready(function( $ ) {

    $(window).scroll(function() {    
		var scroll = $(window).scrollTop();

		if (scroll >= 100) {
			$("#wrapper-navbar").addClass("scrollHeader");
		} else {
			$("#wrapper-navbar").removeClass("scrollHeader");
		}
	});

	$(".scrolling-carousel-top").owlCarousel({
		
        loop: true,
        margin: 5,
        autoplay: true,
        slideTransition: 'linear',
        autoplayTimeout: 0,
        autoplaySpeed: 7000,
        autoplayHoverPause: false,
		dots: false,
		mouseDrag: false,
		touchDrag: false,
		pullDrag: false,
		responsiveClass:true,
		responsive: {
			0:{
				items: 3
			},
			600: {
				items: 5
			},
			900: {
				items: 7
			}

		}

	});

	$(".scrolling-carousel-bottom").owlCarousel({
		
        loop: true,
        margin: 5,
        autoplay: true,
        slideTransition: 'linear',
        autoplayTimeout: 0,
        autoplaySpeed: 7000,
        autoplayHoverPause: false,
		dots: false,
		mouseDrag: false,
		touchDrag: false,
		pullDrag: false,
		responsiveClass:true,
		responsive: {
			0:{
				items: 3
			},
			600: {
				items: 5
			},
			900: {
				items: 7
			}

		}

	});

}); // end document.ready